export const environment = {
  production: false,
  apiUrl: 'https://justifacil.softmanagement.com.co/devcore',
  localApiUrl: 'http://localhost:80',
  intApiUrl: 'https://fn-minjusticia-historial-dev.azurewebsites.net',
  loadApiUrl: 'https://fn-minjusticia-carga-dev.azurewebsites.net',
  porcessApiUrl: 'https://fn-minjusticia-procesamiento-dev.azurewebsites.net',
  pqrs: "https://www.minjusticia.gov.co/atencion-y-servicios-a-la-ciudadania/pqrdsf",
  justinoApiUrl: 'http://localhost:8000',
  justinoModelUrl: 'http://localhost:7000',
  justinoWebhookUrl: 'http://localhost:5000',
  downloadApiUrl: 'https://justifacil.softmanagement.com.co/descargas/dev',
  esHttps: false,
  AUTH_FRONT: 'https://stg-adlu.minjusticia.gov.co',
  AUTH_URL: 'http://192.168.8.60:8000/api',
  ID_ENTITY: '42B25D16-7A2A-4F5C-A693-C714B2965807',
  esLaboratorio: 'false',
  recaptchaSiteKey: '6LeGch4qAAAAAI1r4O_yVgrmqAx5q68ND2x3-LD9',
  AUTH_LOGOUT_TAB_URL: 'http://192.168.8.60:10500/auth/logout-tab',
};
